import axios from 'axios';

export default function  setAuthorizationToken(token) {
    if(localStorage.getItem("tokenRestaurant")){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+token;
    }else{
        delete axios.defaults.headers.common['Authorization'];
    }
};